import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import customiseSectionTitleStyles from './customiseSectionTitleStyles';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../hooks/navigation/useScrollToSection';
import ShowIfTranslationExists from '../../../../../../common/components/ShowIfTranslationExists';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';

export interface ICustomiseSectionTitleProps {
  label?: string;
  translationId?: string;
  testId?: string;
}

const CustomiseSectionTitle: FC<ICustomiseSectionTitleProps> = ({ label, translationId, testId }) => {
  const styles = customiseSectionTitleStyles();
  const { scrollToDisclaimer } = useScrollToSection();
  const id = translationId ?? `trans__configurator__customise_page_${label}_section__section_title`;

  return (
    <Typography
      component={'h3'}
      variant="sectionTitle"
      className={styles.title}
      data-test={`accordion:toggle:sectionTitle:${testId}`}
    >
      <Translation id={id} />
      <ShowIfTranslationExists translationKey={`trans__configurator__indicative_numbers__${label}`}>
        <IndicativeNumber
          dataTest={`${label}`}
          displayNumber={<Translation id={`trans__configurator__indicative_numbers__${label}`} />}
          onClick={scrollToDisclaimer}
          className={styles.indicativeNumber}
        />
      </ShowIfTranslationExists>
    </Typography>
  );
};

export default CustomiseSectionTitle;
